import { render } from "./Base_Display.vue?vue&type=template&id=6584a406&scoped=true"
import script from "./Base_Display.vue?vue&type=script&lang=js"
export * from "./Base_Display.vue?vue&type=script&lang=js"

import "./Base_Display.vue?vue&type=style&index=0&id=6584a406&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6584a406"]])

export default __exports__